// extracted by mini-css-extract-plugin
module.exports = {"tableRow":"job-description-table-element_component_tableRow__xud1p"};